




import {Component, Vue} from "vue-property-decorator";
import JWT from "jwt-decode";
import store from "@/store";
import System from "@/model/system";
import { ReloadManager } from "@/common/util/reloadManager";
import { v4 as uuidv4 } from "uuid";

@Component({
  name: "Login",
})
export default class Login extends Vue {
  private codes;
  private system: System;

  async mounted() {
    Vue.prototype.isLoading = true

    const jwtToken = this.$route.query.code?.toString();

    if (jwtToken) {
      try {
        this.codes = JWT(jwtToken);
        this.system = new System({
          code: jwtToken,
          shop_token: this.codes['shop_token'],
          session_token: this.codes['session_token'],
          image_endpoint: this.codes['image_endpoint'],
          topic_up: this.codes['topic_up'],
          topic_down: this.codes['topic_down'],
          topic_wc: this.codes['topic_wc'],
          datetime: this.codes['datetime'],
          request_token: uuidv4(),
          customer_token: uuidv4(),
          is_close_a_y_c_confirm: false,
        });
        store.dispatch('SystemStore/setSystem', this.system);
        store.dispatch('Auth/updateToken', jwtToken);
      } catch (error) {
        console.log(error);
        this.$router.replace({name : 'error'})
      }

      this.$router.replace({name : 'menu'})
    } else {
      this.$router.replace({name : 'error'})
    }
  }

  async created() {
    // todo will open when use relay server
    store.dispatch('MenuStore/clearList');
    store.dispatch('OptionStore/clearList');
    store.dispatch('MenuSetStore/clearList');
    store.dispatch('OrderStore/clearList');
    store.dispatch('HistoryStore/clear');
    store.dispatch('TableStore/clear');
    store.dispatch('CategoryStore/clear');
    store.dispatch('CategoryStore/clearSub');
  }
}
